import { safeApiRequest } from './apiClient';

/**
 * Teknik servise ait teknisyenleri getir
 * @param {string} techServiceId - Teknik servis ID
 * @returns {Promise}
 */
export const fetchTechniciansByTechService = async (techServiceId) => {
  if (!techServiceId) {
    throw new Error('Teknik servis ID gereklidir');
  }
  
  return safeApiRequest(`/api/tech-services/${techServiceId}/technicians`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Teknisyenin müsaitlik planlarını getir
 * @param {string} technicianId - Teknisyen ID
 * @param {Object} params - Query parametreleri
 * @param {string} params.type - 'oneTime' | 'recurring' | 'all'
 * @param {string} params.startDate - YYYY-MM-DD
 * @param {string} params.endDate - YYYY-MM-DD
 * @returns {Promise}
 */
export const fetchTechnicianAvailability = async (technicianId, params = {}) => {
  if (!technicianId) {
    throw new Error('Teknisyen ID gereklidir');
  }
  
  const queryParams = {};
  
  if (params.type) {
    queryParams.type = params.type;
  }
  
  if (params.startDate) {
    queryParams.startDate = params.startDate;
  }
  
  if (params.endDate) {
    queryParams.endDate = params.endDate;
  }
  
  return safeApiRequest(`/api/technicians/${technicianId}/availability`, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Yeni müsaitlik planı oluştur
 * @param {string} technicianId - Teknisyen ID
 * @param {Object} data - Plan verisi
 * @param {string} data.type - 'oneTime' | 'recurring'
 * @param {string} data.tarih - YYYY-MM-DD (oneTime için)
 * @param {number} data.gun - 0-6 (recurring için)
 * @param {boolean} data.tumGun - Tüm gün off mu?
 * @param {Array<string>} data.saatler - Saat listesi ["09:00", "10:00"]
 * @param {string} data.notlar - Opsiyonel not
 * @returns {Promise}
 */
export const createAvailability = async (technicianId, data) => {
  if (!technicianId) {
    throw new Error('Teknisyen ID gereklidir');
  }
  
  if (!data.type) {
    throw new Error('Plan tipi gereklidir');
  }
  
  // Validation
  if (data.type === 'oneTime' && !data.tarih) {
    throw new Error('Tek seferlik plan için tarih gereklidir');
  }
  
  if (data.type === 'recurring' && data.gun === undefined) {
    throw new Error('Tekrarlı plan için gün gereklidir');
  }
  
  if (!data.tumGun && (!data.saatler || data.saatler.length === 0)) {
    throw new Error('Tüm gün değilse saat listesi gereklidir');
  }
  
  return safeApiRequest(`/api/technicians/${technicianId}/availability`, {
    method: 'POST',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Müsaitlik planını güncelle
 * @param {string} technicianId - Teknisyen ID
 * @param {string} availabilityId - Plan ID
 * @param {Object} data - Güncellenecek veriler
 * @returns {Promise}
 */
export const updateAvailability = async (technicianId, availabilityId, data) => {
  if (!technicianId) {
    throw new Error('Teknisyen ID gereklidir');
  }
  
  if (!availabilityId) {
    throw new Error('Plan ID gereklidir');
  }
  
  return safeApiRequest(`/api/technicians/${technicianId}/availability/${availabilityId}`, {
    method: 'PUT',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Müsaitlik planını sil
 * @param {string} technicianId - Teknisyen ID
 * @param {string} availabilityId - Plan ID
 * @returns {Promise}
 */
export const deleteAvailability = async (technicianId, availabilityId) => {
  if (!technicianId) {
    throw new Error('Teknisyen ID gereklidir');
  }
  
  if (!availabilityId) {
    throw new Error('Plan ID gereklidir');
  }
  
  return safeApiRequest(`/api/technicians/${technicianId}/availability/${availabilityId}`, {
    method: 'DELETE',
    skipCsrf: false,
  });
};
